import capitalize from 'lodash/capitalize'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'
import set from 'lodash/set'
import logger from '@/logger'
import objects from '@/objects'
import router from '@/router'
import store from '@/store'
import utils from '@/utils'

class D2C_Entity extends Object {
  hasPage = false
  static fields = {}
  static results = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
  }
  static fields = {}
  static create(props) {
    if (props.target) {
      const className = props.target[0].toUpperCase() + props.target.substr(1)
      return objects[className].create(props)
    } else {
      logger.warning('Method is not defined')
    }
  }
  get _doesExist() {
    return Boolean(this.created)
  }
  get _inProgress() {
    return Boolean(this.process)
  }
  get _inQueue() {
    return this.process === this.constructor.processes.QUEUED
  }
  get _wasSuccessful() {
    return this.lastResult === this.constructor.results.SUCCESS
  }
  get _wasFailed() {
    return this.lastResult === this.constructor.results.FAIL
  }
  get _defaults() {
    const values = {}
    const fields = this.constructor.fields
    for (const prop in fields) {
      set(values, fields[prop].path || prop, cloneDeep(fields[prop].default))
    }
    return values
  }
  get _values() {
    const values = {}
    const fields = this.constructor.fields
    for (const prop in fields) {
      set(values, fields[prop].path || prop, get(this, fields[prop].path || prop))
    }
    return values
  }
  get _status() {
    return {
      color: utils.getStatusColor(this),
      icon: utils.getStatusIcon(this),
      text: capitalize(this.lastResult || this.process || this.status).replace(/_/g, ' '),
    }
  }
  get _clone() {
    return cloneDeep(this)
  }
  get _owner() {
    return store.getters.accountsById[this.owner]
  }
  constructor(props) {
    super()
    props = Object.assign(this._defaults, props)
    props = Object.keys(props).sort().reduce((acc, key) => ({ ...acc, [key]: props[key] }), {})
    Object.assign(this, props)
  }
  openPage() {
    if (this.hasPage) {
      router.push(`/${this.target}s/${this.name}`)
    } else {
      logger.warning('The entity doesn\'t have its page')
    }
  }
  create() {
    logger.warning('Method is not defined')
  }
  update() {
    logger.warning('Method is not defined')
  }
  destroy() {
    logger.warning('Method is not defined')
  }
  upsert() {
    if (this._doesExist) {
      return this.update()
    } else {
      return this.create()
    }
  }
  validate(mode) {
    return this.getErrors(mode)
  }
  getFields(mode, extraRules = {}) {
    const allFields = this.constructor.fields
    const newFields = {}
    mode = mode || (this._doesExist ? 'updating' : 'creating')
    for (const prop in allFields) {
      const field = allFields[prop]
      const extra = extraRules[prop]
      if (field[mode]) {
        const newField = Object.assign({path: prop}, field, field[mode], extra)
        newField.value = get(this, newField.path)
        newField.error = field.omit ? null : field.validate(newField.value, this, mode)
        newFields[prop] = newField
      }
    }
    return newFields
  }
  getValues(mode) {
    const values = {}
    const fields = this.getFields(mode)
    mode = mode || (this._doesExist ? 'updating' : 'creating')
    for (const prop in fields) {
      if (!fields[prop].omit) {
        let value = get(this, fields[prop].path)
        if (fields[prop].prepare) {
          value = fields[prop].prepare(value, this, mode)
        }
        if (typeof value !== 'undefined') {
          set(values, fields[prop].path, value)
        }
      }
    }
    return values
  }
  getErrors(mode) {
    const errors = {}
    const fields = this.getFields(mode)
    mode = mode || (this._doesExist ? 'updating' : 'creating')
    for (const prop in fields) {
      const value = get(this, fields[prop].path)
      if (!fields[prop].omit) {
        errors[prop] = fields[prop].validate(value, this, mode)
      }
    }
    return errors
  }
  getChanges(mode) {
    const changes = {}
    const oldValues = store.getters[`${this.target}sById`][this.id] || {}
    const newValues = this.getValues(mode)
    for (const prop in newValues) {
      if (!isEqual(oldValues[prop], newValues[prop])) {
        changes[prop] = newValues[prop]
      }
    }
    return changes
  }
}

export default D2C_Entity
